export default __webpack_public_path__ + "static/media/moyo-three-step.4df15aae.svg";